<template>
  <el-form
    class="auditModel"
    ref="formRef"
    :model="formData"
    :rules="rules"
    label-width="130px"
    label-suffix="："
  >
    <el-form-item label="审核结果" prop="status">
      <el-radio-group
        v-model="formData.status"
        @change="$refs.formRef.clearValidate()"
      >
        <el-radio :label="2">通过</el-radio>
        <el-radio :label="3">不通过</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="审核意见"
      prop="remark"
      :rules="[{ required: formData.status == 3, message: '请输入审核意见' }]"
    >
      <el-input
        type="textarea"
        :autosize="{ minRows: 6, maxRows: 6 }"
        show-word-limit
        maxlength="100"
        v-model="formData.remark"
        suffix-icon="el-icon-date"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <!-- <el-form-item label="文件上传">
      <UploadFile
        type="other"
        class="ml10"
        ref="uploadRef"
        @success="uploadSuccess"
        v-model="formData.filePath"
      ></UploadFile>
      <div class="ml10" v-show="formData.fileName">
        <span>{{ formData.fileName }}</span>
        <i class="el-icon-close cursor ml10" @click="handleRemoveFile()"></i>
      </div>
    </el-form-item> -->
    <div class="disfr jc ac">
      <el-button size="small" type="primary" @click="handleSubmitAudit"
        >提交</el-button
      >
    </div>
  </el-form>
</template>

<script>
import UploadFile from "@/components/UploadFile.vue";
export default {
  components: { UploadFile },
  props: {
    detailData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formData: {
        fileName: "",
      },
      rules: {
        status: [{ required: true, message: "请选择审核结果" }],
      },
    };
  },
  methods: {
    uploadSuccess(file) {
      this.formData.filePath = file.accessPath;
      this.formData.fileName = file.fileName;
    },
    handleRemoveFile() {
      this.formData.filePath = "";
      this.formData.fileName = "";
    },
    handleSubmitAudit() {
      this.$refs.formRef.validate((valid) => {
        // const uploadValid = this.$refs.uploadRef.getValidate();
        if (valid) {
          this.formData.backendType = this.detailData.backendType;
          this.$emit("submit", this.formData);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.auditModel {
  width: 60%;
  margin: 0 auto;
  .el-input,
  .el-textarea {
    display: inline-block;
    width: 300px;
  }
  .formItemRemark {
    font-size: 12px;
    // width:700px;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 12px;
    padding-right: 12px;
  }
  .el-date-editor .el-input__prefix {
    left: auto;
    right: 5px;
  }
}
</style>
